// CSS 

//Lib 

// Event, Dialog 

// Api
import api from '@/api/baseApi';

// Constant 
import { SETTINGS_USER_HISTORY_API } from "@/constant/apiSettings";
import { API_CALL_STATUS } from "@/constant/baseConstant";
import { EXTRA_SERVICE_HISTORY_FILTER_BY } from "@/constant/extraService";

// Extend
import baseExtraService from '@/scripts/extraService/baseExtraService';

// Components 
import CaretTop from "@/views/component/Icon/CaretTop.vue";
import CaretBottom from "@/views/component/Icon/CaretBottom.vue";
import Rating from "@/views/component/UserHistory/Rating.vue";

// Function 
const queryString = require('query-string');

export default {

  components: {
    CaretTop,
    CaretBottom,

    Rating,
  },

  extends: baseExtraService,

  data() {
    return {
      filterList: [
        {
          value: 0,
          label: 'All'
        },
        {
          value: 1,
          label: 'Account'
        },
        {
          value: 2,
          label: 'Machine'
        },
        {
          value: 3,
          label: 'Rating'
        },
      ],
      pagination: {
        filter: 3,
        orderBy: 'A.CREATED_AT',
        directionSort: 'DESC',
        pageIndex: 1,
        pageSize: 20,
        outRowsNumber: 0,
      },
      listData: [],
    }
  },

  created() {
    this.getData();
  },

  methods: {

    //#region Processing event
    processingEvent(param) {
      this[param.event](param.data);
    },
    //#endregion

    //#region Action
    action(param) {
      let action = this.$action;
      switch (param) {
        case action.CLICK_REFRESH_EXTRA_SERVICE_HISTORY_VIEW:
          this.getData();
          break;
      }
    },
    //#endregion

    // Sort list
    sortList(element) {
      this.pagination.pageIndex = 1;
      this.pagination.orderBy = element;
      if (this.pagination.directionSort === 'ASC') {
        this.pagination.directionSort = 'DESC'
      } else {
        this.pagination.directionSort = 'ASC'
      }
      this.getData();
    },

    // Pagination size change
    handleSizeChange(pageSize) {
      this.pagination.pageIndex = 1;
      this.pagination.pageSize = pageSize;
      this.getData();
    },

    // Pagination page change
    handleCurrentChange(element) {
      this.pagination.pageIndex = element;
      this.getData();
    },

    //#region Get data
    getData() {
      this.feedStatusLoading(API_CALL_STATUS.LOADING);
      api.baseRequest(SETTINGS_USER_HISTORY_API.ACTIVITY_LOG, null, `?${queryString.stringify(this.pagination)}`)
        .then((res) => {
          let responseData = res.data;
          let pagingItem = responseData.pagingItem;
          let data = responseData.data;
          data.forEach(element => {
            element.content = JSON.parse(element.content);
          });
          this.listData = data;
          this.pagination.orderBy = pagingItem.orderBy;
          this.pagination.directionSort = pagingItem.directionSort;
          this.pagination.pageIndex = pagingItem.pageIndex;
          this.pagination.pageSize = pagingItem.pageSize;
          this.pagination.outRowsNumber = pagingItem.outRowsNumber;
          this.feedStatusLoading(API_CALL_STATUS.SUCCESS, this.listData);
        })
        .catch(error => {
          this.processCatchApiRequest(error, "Extra service history view failed ...")
        });
    },
    //#endregion 
  },
}